import React from "react";
import { Stack, Typography } from "@mui/material";
import { T } from "theme/tokens";

export default function SectionTitle({ children, action, sx }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 1.2, ...sx }}
    >
      <Typography
        sx={{
          fontSize: "0.68rem",
          fontWeight: 700,
          color: T.muted,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
        }}
      >
        {children}
      </Typography>
      {action}
    </Stack>
  );
}
